import { store } from "./store.ts";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { IRootReducer } from "./rootReducers.ts";

export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<IRootReducer> = useSelector;
